angular.module('Mineler').run(['$templateCache', function($templateCache) {
  $templateCache.put('help/help.tpl.html',
    '<div id="help-container">\n' +
    '  <iframe src="https://www.mineler.com/help/"></iframe>\n' +
    '</div>\n' +
    '');
}]);
